import { render, staticRenderFns } from "./PagesContainer.vue?vue&type=template&id=f66d73f4&"
import script from "./PagesContainer.vue?vue&type=script&lang=js&"
export * from "./PagesContainer.vue?vue&type=script&lang=js&"
import style0 from "./PagesContainer.vue?vue&type=style&index=0&id=f66d73f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports